import { action as createAction, Action as ActionType } from "@iva/store-utils";
import {
    AppDispatch,
    ErrorPayload,
    ErrorState,
    GetState,
    IoState,
    IoStateEnum,
    ThunkResult,
} from "#store/types";
import { AutocompleteResponse } from "#services/pilotService/types";

export enum AutocompleteActionIdentifiers {
    FETCH_FROM_FROM_SERVER_SUCCEEDED = "@@operatorInvocations/FETCH_SUCCESS", // result from a successful read!
    FETCH_FROM_SERVER_STARTED = "@@operatorInvocations/FETCH_STARTED",
    FETCH_FROM_SERVER_FAILED = "@@operatorInvocations/FETCH_FAILED",
}

export type LoadStartActionType = ActionType<
    AutocompleteActionIdentifiers.FETCH_FROM_SERVER_STARTED,
    string
>;
export type LoadErrorActionType = ActionType<
    AutocompleteActionIdentifiers.FETCH_FROM_SERVER_FAILED,
    ErrorPayload
>;
export type LoadSuccessActionType = ActionType<
    AutocompleteActionIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED,
    AutocompletionResult
>;

export type AutocompleteActionTypes =
    | LoadStartActionType
    | LoadErrorActionType
    | LoadSuccessActionType;

// TODO: Update
export type AutocompletionResult = {
    id: string;
    tables: string[];
    columns: string[];
    // completions: string[];
};

/*******************************************************************************
 * Reducer related stuff
 ******************************************************************************/

// State definition
export interface AutocompleteState {
    readonly autocompletions: {
        [key: string]: IoState<AutocompletionResult>;
    };
    // readonly query: string;
    // readonly pending: boolean[];
    // readonly requestId: string;
    // readonly tableResults: IQueryTableResult[];
}

function autocompleteFetchStarted(sql: string): LoadStartActionType {
    return createAction(
        AutocompleteActionIdentifiers.FETCH_FROM_SERVER_STARTED,
        sql
    );
}

function autocompleteFetchSucceeded(
    result: AutocompletionResult
): LoadSuccessActionType {
    return createAction(
        AutocompleteActionIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED,
        result
    );
}

function autocompleteFetchFailed(error: ErrorPayload): LoadErrorActionType {
    return createAction(
        AutocompleteActionIdentifiers.FETCH_FROM_SERVER_FAILED,
        error
    );
}

const initialState: AutocompleteState = {
    autocompletions: {},
};

// The reducer function
export function autocompleteReducer(
    state = initialState,
    action: AutocompleteActionTypes
): AutocompleteState {
    switch (action.type) {
        case AutocompleteActionIdentifiers.FETCH_FROM_SERVER_STARTED: {
            const newKey = action.payload;
            return {
                ...state,
                autocompletions: {
                    ...state.autocompletions,
                    [newKey]: {
                        state: IoStateEnum.fetching,
                        payload: null,
                        timestamp: new Date(),
                        error: null,
                    },
                },
            };
        }
        case AutocompleteActionIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED: {
            const newKey = action.payload.id;
            // console.log("got new autocomplete '" + newKey + "'");

            return {
                ...state,
                autocompletions: {
                    ...state.autocompletions,
                    [newKey]: {
                        state: IoStateEnum.done,
                        payload: action.payload,
                        timestamp: new Date(),
                        error: null,
                    },
                },
            };
        }
        case AutocompleteActionIdentifiers.FETCH_FROM_SERVER_FAILED: {
            return {
                ...state,
                autocompletions: {
                    ...state.autocompletions,
                    [action.payload.id]: {
                        state: IoStateEnum.error,
                        error: action.payload,
                        timestamp: new Date(),
                        payload: null,
                    } as ErrorState,
                },
            };
        }
        default: {
            return state;
        }
    }
}
